export const suffix = '-24866';
//# sourceMappingURL=tag-suffix.js.map